import React, { useState, useEffect, useCallback } from "react";
import "./organization-discount-delete.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMatch } from "react-router-dom";
import {
  clearNotifications,
  selectDiscountNotifications,
  selectDiscount,
  deleteOrganizationDiscount,
  getOrganizationDiscountCode,
} from "../../reducers/discountSlice";

import { setNotifications } from "../../reducers/appSlice";
import { getRemoveTitle, removeItemForm } from "../../forms/DeleteForm";
import OrganizationDiscountItem from "./organization-discount-item";

const OrganizationDiscountDelete = () => {
  const [isValid, setIsValid] = useState(true);
  const [discount, setDiscount] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const matchEdit = useMatch("/:id/discounts/:discountID/*");

  const orgNotifications = useSelector(selectDiscountNotifications);
  const currentDiscount = useSelector(selectDiscount);

  const timeoutAction = useCallback(() => {
    dispatch(clearNotifications());
  }, [dispatch]);

  const backToList = useCallback(() => {
    navigate(`/${matchEdit.params.id}/discounts`);
  }, [navigate, matchEdit.params.id]);

  const loadDiscount = useCallback(() => {
    if (matchEdit?.params?.discountID !== "add") {
      dispatch(getOrganizationDiscountCode(matchEdit?.params?.discountID));
    } else {
      dispatch(setDiscount({}));
    }
  }, [dispatch, matchEdit?.params?.discountID]);

  const unloadDiscount = useCallback(() => {
    dispatch(clearNotifications());
  }, [dispatch]);

  useEffect(() => {
    loadDiscount();
    return () => {
      unloadDiscount();
    };
  }, [loadDiscount, unloadDiscount]);

  useEffect(() => {
    setDiscount(currentDiscount);
  }, [currentDiscount]);

  useEffect(() => {
    if (
      orgNotifications.length > 0 &&
      orgNotifications[0].state === "success"
    ) {
      dispatch(setNotifications(orgNotifications));
      backToList();
    }
  }, [orgNotifications, backToList, dispatch]);

  const removeDiscount = () => {
    setIsValid(false);
    if (matchEdit.params.discountID) {
      dispatch(deleteOrganizationDiscount(matchEdit?.params?.discountID));
    }
  };

  const leftNavigation = () => {
    navigate(-1);
  };
  const getActions = () => {
    let actions = [
      {
        name: "Delete",
        action: removeDiscount,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    return actions;
  };

  const getNavigation = () => {
    return {
      title: "Delete Discount",
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const hasNotifications = (notifications) => {
    return notifications && notifications.length > 0;
  };

  const getBanner = () => {
    const slideOutNotifications = orgNotifications;
    if (hasNotifications(slideOutNotifications)) {
      return {
        notifications: slideOutNotifications.map((n) => ({
          ...n,
          pageActions: getBannerActions(),
        })),
        timeoutAction: timeoutAction,
        timeout: 10000,
      };
    }
  };
  const getBannerActions = () => {
    return [
      {
        id: 1,
        title: "Back to discount list",
        size: "secondary",
        actionClick: backToList,
      },
    ];
  };

  const getContent = () => {
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete Discount")}
        formSections={removeItemForm(
          discount.description,
          <OrganizationDiscountItem {...discount} />,
          "delete"
        )}
      />
    );
  };
  const getDrawer = () => {
    return {
      actions: getActions(),
    };
  };
  return (
    <organization-discount-delete>
      <GSSidePanelPage
        header={getNavigation()}
        banner={getBanner()}
        content={getContent()}
        drawer={getDrawer()}
      />
    </organization-discount-delete>
  );
};

export default OrganizationDiscountDelete;
